import TextSection from './TextSection'

export default TextSection
